// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { configurations } from "./configurations/configurations";

export const environment = {
  production: false,
  endPoints: [
    {
      baseName: 'ApplicationInsights',
      api: 'api/ApplicationInsights',
       scopes: [
         'api://ee1ef083-c5fd-4d64-8033-380cc0f86c29/Read',
       ],
    },
    ],
  clientId: 'ee1ef083-c5fd-4d64-8033-380cc0f86c29',
  ...configurations,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
